var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-popover", {
    staticStyle: {
      margin: "0 10px"
    },
    attrs: {
      placement: "top-start",
      title: this.user.user_type > 0 ? "警告内容" : "通知内容",
      width: "200",
      trigger: "hover",
      content: _vm.noticeContent
    }
  }, [_c("el-button", {
    attrs: {
      slot: "reference",
      size: "big",
      type: "warning"
    },
    on: {
      click: _vm.sendHouseNotice
    },
    slot: "reference"
  }, [_vm._v(_vm._s(this.user.user_type > 0 ? "警告" : "通知"))])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };